import React, { useEffect, useRef, useState } from "react";
import TranslateFile from "../Loc/TranslateFile";
const VideoCall = () => {
  const iframeRef = useRef(null);
  const currentLang = TranslateFile();
  const inmateId = JSON.parse(localStorage.getItem("loginResponse"))?.InmateID;
  //const URL = "http://localhost:3000/";
  const URL = "https://inmate-videocall-kiosk.sgssys.info/";
  const [videoCallUrl, setvideoCallUrl] = useState(`${URL}?inmateId=${encodeURIComponent(inmateId)}`);


  useEffect(() => {
    setvideoCallUrl(`${URL}?inmateId=${encodeURIComponent(inmateId)}`)
  }, [inmateId])



  return (
    <div className="video-call-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-1 pt-1 header-panel">
        <div className="align-self-start">
          <div className="icon-container">
            <h3 className="find-inmate-head">
              {currentLang?.MyInvites?.visitationHistoryAndUpcomingCalls ||
                "VISITATIONS HISTORY AND UPCOMING CALLS"}
            </h3>
          </div>
        </div>
      </div>
      <div class="divider">
      </div>
      {/* Iframe section */}
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          ref={iframeRef}
          src={videoCallUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
          allow="camera; microphone"
          title="Video Call"
        />
      </div>
    </div>
  );
};
export default React.memo(VideoCall);